import PropTypes from 'prop-types';
import React from 'react';

import ArchiveLicenseStatusContainer from 'components/ArchiveLicenseStatusContainer';

const ArchiveRetentionStrategySummary = React.createClass({
  propTypes: {
    config: PropTypes.object.isRequired,
  },

  componentDidMount() {
    this.style.use();
  },

  componentWillUnmount() {
    this.style.unuse();
  },

  style: require('!style/useable!css!style.css'),

  render() {
    return (
      <div>
        <dl>
          <dt>Index retention strategy:</dt>
          <dd>Archive</dd>
          <dt>Max number of indices:</dt>
          <dd>{this.props.config.max_number_of_indices}</dd>
          <dt>Index action:</dt>
          <dd>{this.props.config.index_action}</dd>
        </dl>
        <ArchiveLicenseStatusContainer summary />
      </div>
    );
  },
});

export default ArchiveRetentionStrategySummary;



// WEBPACK FOOTER //
// ./src/web/components/ArchiveRetentionStrategySummary.jsx